import { LuGlobe, LuPhone, LuShield, LuUsers } from 'react-icons/lu';

const breadcrumbItems = [
    {
        label: 'Admin',
        href: '/admin',
    },
    {
        label: 'Resources',
        href: '/admin',
    },
    {
        label: 'TRS Feature Disabled',
    },
];

const reasons = [
    {
        title: 'The Rise of UCaaS',
        description:
            'The rise of UCaaS platforms such as Microsoft Teams, WebEx Calling and Zoom phone continues to increase in popularity and adoption, driven by simplicity and cost savings',
    },
    {
        title: 'Feature Demand',
        description:
            'However, some customer use cases require functionality and integrations above what these can provide.',
    },
    {
        title: 'The Hard Choice',
        description:
            'Customers may be forced to migrate, potentially sacrificing functionality and incurring risk',
    },
    {
        title: 'SIP Registration and Interoperability',
        description:
            'The convenience of UCaaS platforms, with the functionality set of a Customers or Partners PBX',
    },
];

const customerExpectations = [
    {
        title: 'Native Experience',
        description:
            'All calling functionality—dialing, transferring, voicemail, call history—occurs directly within the UCaaS client',
    },
    {
        title: 'Preservation',
        description:
            'No need to change carriers, port numbers, or replace your current PBX',
    },
    {
        title: 'Fast & Low Risk',
        description:
            'No hardware required, few specialist skills needed—minimal disruption to existing systems',
    },
    {
        title: 'Scalable',
        description:
            'Supports large environments across a global infrastructure',
    },
];

const features = [
    {
        icon: LuPhone,
        title: 'SIP Registration',
        description:
            'TRS acts as a central hub for managing registrations, providing seamless authentication and registration functions to ensure smooth communication within SIP networks',
    },
    {
        icon: LuUsers,
        title: 'Combine UCaaS + PBX',
        description:
            'Combine the features of Microsoft Teams and other UCaaS platforms with the full functionality of a PBX',
    },
    {
        icon: LuGlobe,
        title: 'Global',
        description:
            'Register to a local point of presence relative to the platform',
    },
    {
        icon: LuShield,
        title: 'High Availability',
        description:
            'TRS operates a fully redundant architecture with multiple nodes per region',
    },
    {
        icon: LuUsers,
        title: 'Partner & Customer Focus',
        description: 'Supporting managed PBX\'s or customer dedicated devices',
    },
    {
        icon: LuShield,
        title: 'Credibility',
        description:
            'Powered by TCAP, providing a unified and trusted telephony platform',
    },
];

export { breadcrumbItems, reasons, customerExpectations, features };
